// src/components/Notifications.jsx

import React from 'react';
import { AlertTriangle, CheckCircle, Info } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Notifications = ({ notifications = [] }) => {
  const { t } = useLanguage();

  const typeConfig = {
    warning: {
      icon: AlertTriangle,
      badge: 'bg-orange-100 text-orange-700',
      ring: 'border-orange-200',
      dot: 'bg-orange-500'
    },
    info: {
      icon: Info,
      badge: 'bg-blue-100 text-blue-700',
      ring: 'border-blue-200',
      dot: 'bg-blue-500'
    },
    success: {
      icon: CheckCircle,
      badge: 'bg-emerald-100 text-emerald-700',
      ring: 'border-emerald-200',
      dot: 'bg-emerald-500'
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 transition-shadow duration-200">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">{t('nav.notifications')}</h2>
          <p className="text-sm text-slate-600">{t('notifications.subtitle')}</p>
        </div>
        <span className="text-xs text-slate-500">
          {notifications.filter((notification) => notification.unread).length} {t('nav.unread')}
        </span>
      </div>

      <div className="space-y-4">
        {notifications.map((notification) => {
          const config = typeConfig[notification.type] || typeConfig.info;
          const Icon = config.icon;

          return (
            <div
              key={notification.id}
              className={`flex items-start gap-4 rounded-lg border ${config.ring} bg-white p-4 shadow-sm`}
            >
              <div className={`flex h-10 w-10 items-center justify-center rounded-full ${config.badge}`}>
                <Icon size={18} />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between gap-3">
                  <span className={`text-xs uppercase tracking-wide ${config.badge} px-2 py-1 rounded-full`}>
                    {t(`notifications.types.${notification.type}`)}
                  </span>
                  <span className="text-xs text-slate-400">{notification.time}</span>
                </div>
                <p className={`mt-2 text-sm ${notification.unread ? 'font-semibold text-slate-900' : 'text-slate-600'}`}>
                  {notification.message}
                </p>
              </div>
              <span className={`mt-2 h-2 w-2 rounded-full ${notification.unread ? config.dot : 'bg-slate-300'}`} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Notifications;
